<script lang="ts">
  import type Chart from "chart.js";
  import * as chartjs from "chart.js";
  import { onMount, onDestroy } from "svelte";

  export let chartConfig: Chart.ChartConfiguration;
  export let extraClasses: string = "";
  export let height: string = "auto";
  export let width: string = "auto";

  export let chartData;

  let chart: Chart;
  let ctx;
  let chartCanvas;

  const createChart = () => {
    ctx = chartCanvas.getContext("2d");
    chart = new chartjs.Chart(ctx, {
      ...chartConfig,
      data: chartData || chartConfig.data,
    });
  };

  onMount(createChart);

  onDestroy(() => chart.destroy());

  $: {
    /**
     * This will update anytime chartData is regenerated, which means:
     * 1) If a parent component builds a new object even when data hasn't changed, this will update and reanimate more than it should
     * 2) If a parent component mutates chartData instead of building a new object, this won't update
     */
    if (chart && chartData !== chart.data) {
      /**
       * `chart.data = chartData; chart.update()` would be better,
       * but updates animate inconsistently, so destroying and recreating is more reliable.
       */
      chart.destroy();
      createChart();
    }
  }

</script>

<canvas bind:this={chartCanvas} class={extraClasses} {height} {width} />
